import React from 'react';
import ApplicationButtonStyle from './style';
import { Icon, Text, Link } from '@weareconceptstudio/core';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/constants/app-stores';

const defaultData = [
	{
		icon: 'ios',
		url: APP_STORE_URL,
		title: 'downloadApp',
		description: 'appStore',
	},
	{
		icon: 'android',
		url: PLAY_STORE_URL,
		title: 'downloadApp',
		description: 'playStore',
	},
];

const ApplicationButton = ({ isSecondary = false }) => {
	return (
		<ApplicationButtonStyle className={`application-button-wrapper ${isSecondary ? 'is-secondary' : ''}`}>
			{defaultData.map((item) => (
				<div
					key={item.icon}
					className='application-button-item'
				>
					<div className='application-button-item-inner'>
						<Link
							url={item.url}
							external
						>
							<div className='app-block'>
								<Icon
									name={item.icon}
									className={`app-icon ${item.icon}`}
								/>

								<div className='app-block-content'>
									{isSecondary ? null : (
										<Text
											className='p p5 font-montserrat-arm-regular'
											text={item.title}
										/>
									)}

									<Text
										className={`p ${isSecondary ? 'p5' : 'p4'} font-montserrat-arm-bold item-description`}
										text={item.description}
									/>
								</div>
							</div>
						</Link>
					</div>
				</div>
			))}
		</ApplicationButtonStyle>
	);
};

export default ApplicationButton;
